module.exports = __webpack_public_path__ + "img/cafe_international-md.11a70196.jpg";